export default __webpack_public_path__ + "static/media/Team_Generator.1dc1e2b8.gif";